import axios from "axios";

export default function ()
{
    return axios.create({
        baseURL: 'https://pourlo.catalogue-interactif.com/app/api',
        headers: {
            'Content-Type': 'application/json', 
            // 'Cache-Control' : 'no-cache, no-store, must-revalidate'
        },  
    })
}